import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
// Removed `useParams` and `useNavigate` as this is a modal component
// import { useParams, useNavigate } from 'react-router-dom';

// 🔑 CHANGE: Accepts props for id, closing the modal, and refreshing the list
function EditAiGenerators({ id, closeModal, onAiUpdated }) {
  // Use a unique sessionStorage key based on the item ID
  const storageKey = `editAiGeneratorFormData-${id}`;

  // Initialize state from sessionStorage or an empty object
  const [formData, setFormData] = useState(() => {
    const savedData = sessionStorage.getItem(storageKey);
    return savedData ? JSON.parse(savedData) : {
      type: '',
      siteUrl: '',
      description: '',
    };
  });

  // Fetch data on initial load
  useEffect(() => {
    const fetchAiGenerator = async () => {
      try {
        // 🔑 CHANGE: Fetch data using the `id` prop
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/aigenerators/${id}`);
        setFormData(res.data);
      } catch (err) {
        toast.error('Failed to fetch AI Generator data');
        console.error(err);
        closeModal(); // Close modal if data fetch fails
      }
    };

    // Only fetch if an ID is provided
    if (id) {
      fetchAiGenerator();
    }
  }, [id, closeModal]); // Added closeModal to the dependency array

  // Save formData to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem(storageKey, JSON.stringify(formData));
  }, [formData, storageKey]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 🔑 CHANGE: Use the `id` prop for the PUT request
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/aigenerators/${id}`, formData);
      toast.success('AI Generator updated');
      // Clear sessionStorage for this item on successful submit
      sessionStorage.removeItem(storageKey);
      // 🔑 CHANGE: Call the parent's callback functions to refresh and close
      onAiUpdated();
      closeModal();
    } catch (err) {
      toast.error('Error updating AI Generator');
      console.error(err);
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-10 bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">Edit AI Generator</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">Type</label>
          <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Select Type</option>
            <option value="Image Generator">Image Generator</option>
            <option value="Video Generator">Video Generator</option>
          </select>
        </div>

        <div>
          <label className="block font-medium">Site URL</label>
          <input
            type="url"
            name="siteUrl"
            value={formData.siteUrl}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block font-medium">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div className="flex gap-2">
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
            Update
          </button>
          <button
            type="button"
            onClick={closeModal} // 🔑 CHANGE: Call closeModal prop
            className="bg-gray-300 px-4 py-2 rounded"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditAiGenerators;